import React from "react";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faTimes,
    faFilePdf
}
from "@fortawesome/free-solid-svg-icons";


//============================================================
// Mobile Document Viewer
//============================================================

export default function MobileDocumentViewer(
{
    title,
    url,
    closeFunction
})
{

    //--------------------------------------------------------
    // Styles
    //--------------------------------------------------------

    const container =
    {
        position:
            "fixed",

        top:
            "0px",

        left:
            "0px",

        width:
            "100%",

        height:
            "100%",

        zIndex:
            999999,

        display:
            "flex",

        flexDirection:
            "column",

        background:
            "#ffffff"
    };


    const header =
    {
        display:
            "flex",

        alignItems:
            "center",

        flexShrink:
            0,

        height:
            "64px",

        padding:
            "0 12px",

        gap:
            "10px",

        boxSizing:
            "border-box",

        background:
            "rgba(255,255,255,0.94)",

        backdropFilter:
            "blur(20px)",

        WebkitBackdropFilter:
            "blur(20px)",

        borderBottom:
            "1px solid rgba(38,49,61,0.10)",

        boxShadow:
            "0 4px 14px rgba(0,0,0,0.10)"
    };


    const documentIcon =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        width:
            "38px",

        height:
            "38px",

        flexShrink:
            0,

        borderRadius:
            "10px",

        background:
            "#edf5fc",

        color:
            "#3d7bff",

        fontSize:
            "16px"
    };


    const titleStyle =
    {
        flexGrow:
            1,

        minWidth:
            0,

        color:
            "#26313D",

        fontSize:
            "13px",

        fontWeight:
            700,

        overflow:
            "hidden",

        textOverflow:
            "ellipsis",

        whiteSpace:
            "nowrap"
    };


    const closeButton =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        width:
            "42px",

        height:
            "42px",

        flexShrink:
            0,

        borderRadius:
            "50%",

        border:
            "1px solid rgba(255,255,255,0.35)",

        background:
            "linear-gradient(180deg,#1f2937 0%,#111827 100%)",

        boxShadow:
            `
                inset 0 1px 2px rgba(255,255,255,0.35),
                inset 0 -2px 4px rgba(0,0,0,0.25),
                0 4px 10px rgba(0,0,0,0.22)
            `,

        color:
            "#ffffff",

        cursor:
            "pointer",

        fontSize:
            "16px"
    };


    const viewer =
    {
        display:
            "block",

        width:
            "100%",

        flexGrow:
            1,

        minHeight:
            0,

        border:
            "none",

        background:
            "#f2f3f5"
    };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div style={container}>

            {/* ==============================================
                HEADER
            ============================================== */}

            <div style={header}>

                <div style={documentIcon}>

                    <FontAwesomeIcon
                        icon={faFilePdf}
                    />

                </div>


                <div style={titleStyle}>

                    {title || "Document"}

                </div>


                <div
                    style={closeButton}
                    onClick={closeFunction}
                >

                    <FontAwesomeIcon
                        icon={faTimes}
                    />

                </div>

            </div>


            {/* ==============================================
                PDF
            ============================================== */}

            <iframe
                src={url}
                title={title || "Document"}
                style={viewer}
            />

        </div>

    );

}